import bindAll from 'lodash.bindall';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import styles from './theme-manager-modal.css';

const THEME_VISUALS = {
    light: {headerBg: '#162A75', bodyBg: '#FFFFFF', textColor: '#1A1F36'},
    dark: {headerBg: '#0D1D5E', bodyBg: '#1A1F36', textColor: '#EEF1FA'},
    cyan: {headerBg: '#0E7490', bodyBg: '#ECFEFF', textColor: '#083344'}
};

class PreviewCard extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, ['handleClick']);
    }
    handleClick () {
        this.props.onSelect(this.props.themeId);
    }
    render () {
        const {themeId, label, isActive} = this.props;
        const visuals = THEME_VISUALS[themeId] || THEME_VISUALS.light;
        return (
            <button
                type="button"
                className={classNames(styles.previewCard, {[styles.previewCardActive]: isActive})}
                onClick={this.handleClick}
            >
                <div
                    className={styles.previewMini}
                    style={{background: visuals.bodyBg, color: visuals.textColor}}
                >
                    <div
                        className={styles.previewMiniHeader}
                        style={{background: visuals.headerBg}}
                    />
                    <div className={styles.previewMiniBlock}>
                        <span className={styles.previewMiniBlockChip} />
                        <span
                            className={styles.previewMiniBlockLabel}
                            style={{color: visuals.textColor}}
                        >
                            {'move 10 steps'}
                        </span>
                    </div>
                </div>
                <div className={styles.previewLabel}>{label}</div>
            </button>
        );
    }
}

PreviewCard.propTypes = {
    isActive: PropTypes.bool,
    label: PropTypes.node.isRequired,
    onSelect: PropTypes.func.isRequired,
    themeId: PropTypes.oneOf(['light', 'dark', 'cyan']).isRequired
};

export default PreviewCard;
